// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.venue-item {
  border-radius: 0;
  background: white;
  color: var(--ion-color-main);
  transition: 0.3s linear;
  margin-bottom: 10px;
  border: 1px solid #ececec;
  box-shadow: none;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  overflow: hidden;
}
.venue-item.selected {
  transition: 0.3s linear;
  color: var(--ion-color-main);
  border: 4px solid var(--ion-color-secondary);
}
.venue-item p {
  margin: 0;
}
.venue-item .name {
  font-weight: bold;
  font-size: 16px;
}

.distance {
  height: 21px;
  min-width: 45px;
  padding: 2px 8px !important;
  text-align: center;
  margin-right: 5px;
}

.second-row {
  margin-top: 2px;
}

.wrap {
  padding-top: 10px;
}

.map-icon {
  margin-left: 4px;
}

.info-icon {
  margin-left: 2px;
}

a {
  height: 35px;
  width: 35px;
}

.box {
  color: var(--ion-color-main);
  border: 2px solid var(--ion-color-main);
  padding: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.box.selected {
  color: white;
  border: 2px solid white;
}

.venue-status {
  color: white;
  background: var(--ion-color-gold);
  border-radius: 2px;
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px 8px !important;
  min-width: 45px;
  text-align: center;
  margin-right: 5px;
}
.venue-status.selected {
  background: white;
  color: var(--ion-color-primary);
}

.preorder-type {
  color: #7a7a7a;
  cursor: pointer;
  --padding: 16px;
  border-radius: 0;
  padding: 0;
  margin: 0;
  --detail-icon-opacity: 1;
  --border-radius: 0px;
}
.preorder-type .preorder-type-item {
  display: flex;
  width: 100%;
  padding: 10px 2px 10px 10px;
  align-items: center;
  position: relative;
}
.preorder-type .preorder-type-item .next-icon {
  position: absolute;
  bottom: 50%;
  transform: translateY(50%) !important;
  right: 0px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.preorder-type .border {
  border-bottom: 0.5px solid #d5dddd;
}
.preorder-type ion-label {
  flex-direction: column;
  display: flex;
  justify-content: center;
}
.preorder-type .title_name {
  font-size: 16px;
  line-height: 23px;
}
.preorder-type p {
  font-family: AppFontLight, sans-serif;
  font-size: 14px;
}
.preorder-type .title_name {
  color: var(--ion-color-primary) !important;
  font-family: var(--font-tusker);
  opacity: 0.4;
}
.preorder-type p {
  color: #6b6b6b !important;
  opacity: 0.4;
}
.preorder-type ion-icon {
  color: var(--ion-color-second) !important;
  opacity: 0.4;
}

.custom-selected {
  --background: white;
}

.active {
  transition: 0.3s linear;
  color: var(--ion-color-main) !important;
}
.active p {
  color: #313131 !important;
  opacity: 1 !important;
}
.active ion-icon {
  opacity: 1 !important;
}
.active .title_name {
  opacity: 1 !important;
}

.border-top {
  border-top: 0.5px solid #e8e8e8;
}

.align-center {
  text-align: center;
}

.button-separator {
  width: 3px;
  height: 100%;
}

.top-row {
  padding: 0px;
  min-height: 60px;
  border-bottom: 0.5px solid #e5e5e5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  overflow: hidden;
  position: relative;
}
.top-row.selectedVenue {
  min-height: 180px;
  align-items: end !important;
}
@media (min-width: 991px) {
  .top-row {
    cursor: pointer;
  }
}
.top-row .image-block {
  display: none;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.top-row .image-block ion-img {
  width: 100%;
  object-fit: cover;
}
.top-row .image-block .utube {
  width: 45px;
  height: 32px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.top-row .image-block.selectedVenue {
  display: block;
}
.top-row .top-row-info-block {
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.1);
}

.small-margin-top {
  margin-top: 6px;
}

.top-end-img {
  position: absolute;
  top: 0;
  right: 0;
  height: 36px;
  width: 40px;
}

.header-block {
  display: flex;
  align-items: center;
}

.address-block {
  padding: 0px 0px 0px 5px;
}
.address-block ion-row {
  display: flex;
  align-items: center;
}

.eat-icon {
  margin-right: 15px;
  padding: 15px 0px;
}

.info-icon-block {
  display: flex;
  justify-content: flex-end;
  padding-right: 6px;
}

.disabled {
  background: red !important;
  color: var(--ion-color-primary) !important;
}

.enabled {
  background: #34a853 !important;
  color: white !important;
}

.circle {
  padding: 10px;
  border: 1px solid rgba(33, 33, 33, 0.05);
  border-radius: 50%;
  zoom: 0.6;
}
.circle.selected {
  border: 1px solid white;
}

.name-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.name-block .name {
  font-size: 15px;
  text-transform: uppercase;
  font-family: AppFontSemiBold, sans-serif;
  color: var(--ion-color-main) !important;
  margin-bottom: 5px;
}
.name-block .address {
  font-size: 12px;
  color: #313131;
  padding-left: 0px;
  padding-top: 5px;
  font-family: AppFont, sans-serif;
}
.name-block.selectedVenue .name {
  color: white !important;
}
.name-block.selectedVenue .address {
  color: white !important;
}

.info-block {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.info-block .icon {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-block .icon ion-icon {
  height: 35px;
  width: 35px;
}

.label-open {
  color: var(--ion-color-primary);
  font-size: 9px;
  height: auto;
  padding: 4px 3px;
  margin-top: 10px;
  border-radius: 3px;
  margin-left: 0px;
  text-align: center;
  text-transform: uppercase;
  width: 67px;
}
.label-open .enabled {
  background: #00a862;
}
.label-open .disabled {
  background: red;
}
.label-open ion-label {
  color: white;
  font-size: 8px;
}

.open-block {
  display: flex;
  justify-content: flex-end;
}

ion-item {
  border: none !important;
  --border: none !important;
}
ion-item .item-inner {
  border-style: unset !important;
}

.delivery-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: #f7f9f9;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.delivery-section .companie {
  width: 30%;
  border: 0.5px solid #e5e5e5;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 12px 10px;
}
.delivery-section .companie ion-img {
  height: 15px;
}

.logo-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.logo-block .app-logo {
  width: 82px;
  margin-bottom: 10px;
}
.logo-block .title {
  font-size: 21px !important;
  font-family: var(--font-tusker);
  color: var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-suggestion/venue-suggestion.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;AAFF;AAIE;EACE,uBAAA;EACA,4BAAA;EACA,4CAAA;AAFJ;AAKE;EACE,SAAA;AAHJ;AAME;EACE,iBAAA;EACA,eAAA;AAJJ;;AAQA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAmBA;EACE,gBAAA;AAhBF;;AAmBA;EACE,gBAAA;AAhBF;;AAmBA;EACE,YAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,4BAAA;EACA,uCAAA;EACA,YAAA;EACA,0CAAA;AAhBF;AAkBE;EACE,YAAA;EACA,uBAAA;AAhBJ;;AAoBA;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAjBF;AAmBE;EACE,iBAAA;EACA,+BAAA;AAjBJ;;AAqBA;EACE,cAAA;EAEA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;EACA,oBAAA;AAnBF;AAoBE;EACE,aAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;AAmBI;EACE,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAjBN;AAoBE;EACE,kCAAA;AAlBJ;AAqBE;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;AAnBJ;AAqBE;EAEE,eAAA;EACA,iBAAA;AApBJ;AAwBE;EACE,qCAAA;EACA,eAAA;AAtBJ;AAwBE;EACE,0CAAA;EACA,+BAAA;EACA,YAAA;AAtBJ;AAyBE;EACE,yBAAA;EACA,YAAA;AAvBJ;AAyBE;EACE,yCAAA;EACA,YAAA;AAvBJ;;AA0BA;EACE,mBAAA;AAvBF;;AAyBA;EACE,uBAAA;EACA,uCAAA;AAtBF;AAuBE;EACE,yBAAA;EACA,qBAAA;AArBJ;AAuBE;EACE,qBAAA;AArBJ;AAwBE;EACE,qBAAA;AAtBJ;;AA0BA;EACE,+BAAA;AAvBF;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,UAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,gBAAA;EACA,kCAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;AAvBF;AAwBE;EACE,iBAAA;EACA,2BAAA;AAtBJ;ACnLE;EDgMF;IAYI,eAAA;EArBF;AACF;AAsBE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,4BAAA;AApBJ;AAqBI;EACE,WAAA;EACA,iBAAA;AAnBN;AAqBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AAnBN;AAqBI;EACE,cAAA;AAnBN;AAsBE;EACE,iBAAA;EAEA,oCAAA;AArBJ;;AA0BA;EACE,eAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAvBF;;AAyBA;EACE,aAAA;EACA,mBAAA;AAtBF;;AAwBA;EACE,wBAAA;AArBF;AAsBE;EACE,aAAA;EACA,mBAAA;AApBJ;;AAuBA;EACE,kBAAA;EACA,iBAAA;AApBF;;AAsBA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AAnBF;;AAqBA;EACE,0BAAA;EACA,0CAAA;AAlBF;;AAoBA;EACE,8BAAA;EACA,uBAAA;AAjBF;;AAmBA;EACE,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,SAAA;AAhBF;AAiBE;EACE,uBAAA;AAfJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;AAfF;AAgBE;EACE,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,uCAAA;EACA,kBAAA;AAdJ;AAgBE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AAdJ;AAiBI;EACE,uBAAA;AAfN;AAiBI;EACE,uBAAA;AAfN;;AAmBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAhBF;AAiBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfJ;AAgBI;EACE,YAAA;EACA,WAAA;AAdN;;AAkBA;EACE,+BAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAfF;AAgBE;EACE,mBAAA;AAdJ;AAgBE;EACE,eAAA;AAdJ;AAgBE;EACE,YAAA;EACA,cAAA;AAdJ;;AAiBA;EACE,aAAA;EACA,yBAAA;AAdF;;AAgBA;EACE,uBAAA;EACA,yBAAA;AAbF;AAcE;EACE,8BAAA;AAZJ;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EAeA,8BAAA;EACA,+BAAA;AA1BF;AAWE;EACE,UAAA;EACA,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AATJ;AAWI;EACE,YAAA;AATN;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAZF;AAaE;EAEE,WAAA;EACA,mBAAA;AAZJ;AAcE;EACE,0BAAA;EACA,+BAAA;EACA,iCAAA;AAZJ","sourcesContent":["@import \"../../../theme/mixins\";\n\n.venue-item {\n  border-radius: 0;\n  background: white;\n  color: var(--ion-color-main);\n  transition: 0.3s linear;\n  margin-bottom: 10px;\n  border: 1px solid #ececec;\n  // backdrop-filter: blur(10px);\n  box-shadow: none;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n  overflow: hidden;\n\n  &.selected {\n    transition: 0.3s linear;\n    color: var(--ion-color-main);\n    border: 4px solid var(--ion-color-secondary);\n  }\n\n  p {\n    margin: 0;\n  }\n\n  .name {\n    font-weight: bold;\n    font-size: 16px;\n  }\n}\n\n.distance {\n  height: 21px;\n  min-width: 45px;\n  padding: 2px 8px !important;\n  text-align: center;\n  margin-right: 5px;\n}\n\n.second-row {\n  margin-top: 2px;\n}\n\n.wrap {\n  padding-top: 10px;\n}\n\n// .icon {\n//   width: 28px;\n//   height: 28px;\n//   padding: 2px;\n//   color: var(--ion-color-main);\n\n//   &.selected {\n//     color: white;\n//   }\n// }\n\n.map-icon {\n  margin-left: 4px;\n}\n\n.info-icon {\n  margin-left: 2px;\n}\n\na {\n  height: 35px;\n  width: 35px;\n}\n\n.box {\n  color: var(--ion-color-main);\n  border: 2px solid var(--ion-color-main);\n  padding: 2px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\n  &.selected {\n    color: white;\n    border: 2px solid white;\n  }\n}\n\n.venue-status {\n  color: white;\n  background: var(--ion-color-gold);\n  border-radius: 2px;\n  font-size: 13px;\n  width: fit-content;\n  padding: 2px 8px !important;\n  min-width: 45px;\n  text-align: center;\n  margin-right: 5px;\n\n  &.selected {\n    background: white;\n    color: var(--ion-color-primary);\n  }\n}\n\n.preorder-type {\n  color: #7a7a7a;\n  // background: #7A7A7A;\n  cursor: pointer;\n  --padding: 16px;\n  border-radius: 0;\n  padding: 0;\n  margin: 0;\n  --detail-icon-opacity: 1;\n  --border-radius: 0px;\n  .preorder-type-item {\n    display: flex;\n    width: 100%;\n    padding: 10px 2px 10px 10px;\n    align-items: center;\n    position: relative;\n    .next-icon {\n      position: absolute;\n      bottom: 50%;\n      transform: translateY(50%) !important;\n      right: 0px;\n      border-radius: 50%;\n      width: 30px;\n      height: 30px;\n    }\n  }\n  .border {\n    border-bottom: 0.5px solid #d5dddd;\n  }\n\n  ion-label {\n    flex-direction: column;\n    display: flex;\n    justify-content: center;\n  }\n  .title_name {\n    // font-family: var(--font-tusker), sans-serif;\n    font-size: 16px;\n    line-height: 23px;\n    // text-transform: uppercase !important;\n  }\n\n  p {\n    font-family: AppFontLight, sans-serif;\n    font-size: 14px;\n  }\n  .title_name {\n    color: var(--ion-color-primary) !important;\n    font-family: var(--font-tusker);\n    opacity: 0.4;\n    // text-transform: uppercase;\n  }\n  p {\n    color: #6b6b6b !important;\n    opacity: 0.4;\n  }\n  ion-icon {\n    color: var(--ion-color-second) !important;\n    opacity: 0.4;\n  }\n}\n.custom-selected {\n  --background: white;\n}\n.active {\n  transition: 0.3s linear;\n  color: var(--ion-color-main) !important;\n  p {\n    color: #313131 !important;\n    opacity: 1 !important;\n  }\n  ion-icon {\n    opacity: 1 !important;\n  }\n\n  .title_name {\n    opacity: 1 !important;\n  }\n}\n\n.border-top {\n  border-top: 0.5px solid #e8e8e8;\n}\n\n.align-center {\n  text-align: center;\n}\n\n.button-separator {\n  width: 3px;\n  height: 100%;\n}\n\n.top-row {\n  padding: 0px;\n  min-height: 60px;\n  border-bottom: 0.5px solid #e5e5e5;\n  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n  overflow: hidden;\n  position: relative;\n  &.selectedVenue {\n    min-height: 180px;\n    align-items: end !important;\n  }\n  @include desktop {\n    cursor: pointer;\n  }\n  .image-block {\n    display: none;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n    ion-img {\n      width: 100%;\n      object-fit: cover;\n    }\n    .utube {\n      width: 45px;\n      height: 32px;\n      position: absolute;\n      top: 40%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      cursor: pointer;\n    }\n    &.selectedVenue {\n      display: block;\n    }\n  }\n  .top-row-info-block {\n    padding: 5px 10px;\n\n    background: rgba(255, 255, 255, 0.1);\n    // backdrop-filter: blur(5px);\n  }\n}\n\n.small-margin-top {\n  margin-top: 6px;\n}\n\n.top-end-img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 36px;\n  width: 40px;\n}\n.header-block {\n  display: flex;\n  align-items: center;\n}\n.address-block {\n  padding: 0px 0px 0px 5px;\n  ion-row {\n    display: flex;\n    align-items: center;\n  }\n}\n.eat-icon {\n  margin-right: 15px;\n  padding: 15px 0px;\n}\n.info-icon-block {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 6px;\n}\n.disabled {\n  background: red !important;\n  color: var(--ion-color-primary) !important;\n}\n.enabled {\n  background: #34a853 !important;\n  color: white !important;\n}\n.circle {\n  padding: 10px;\n  border: 1px solid rgba(33, 33, 33, 0.05);\n  border-radius: 50%;\n  zoom: 0.6;\n  &.selected {\n    border: 1px solid white;\n  }\n}\n.name-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  text-align: left;\n  .name {\n    font-size: 15px;\n    text-transform: uppercase;\n    font-family: AppFontSemiBold, sans-serif;\n    color: var(--ion-color-main) !important;\n    margin-bottom: 5px;\n  }\n  .address {\n    font-size: 12px;\n    color: #313131;\n    padding-left: 0px;\n    padding-top: 5px;\n    font-family: AppFont, sans-serif;\n  }\n  &.selectedVenue {\n    .name {\n      color: white !important;\n    }\n    .address {\n      color: white !important;\n    }\n  }\n}\n.info-block {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  .icon {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ion-icon {\n      height: 35px;\n      width: 35px;\n    }\n  }\n}\n.label-open {\n  color: var(--ion-color-primary);\n  font-size: 9px;\n  height: auto;\n  padding: 4px 3px;\n  margin-top: 10px;\n  border-radius: 3px;\n  margin-left: 0px;\n  text-align: center;\n  text-transform: uppercase;\n  width: 67px;\n  .enabled {\n    background: #00a862;\n  }\n  .disabled {\n    background: red;\n  }\n  ion-label {\n    color: white;\n    font-size: 8px;\n  }\n}\n.open-block {\n  display: flex;\n  justify-content: flex-end;\n}\nion-item {\n  border: none !important;\n  --border: none !important;\n  .item-inner {\n    border-style: unset !important;\n  }\n}\n.delivery-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background: #f7f9f9;\n  .companie {\n    width: 30%;\n    border: 0.5px solid #e5e5e5;\n    background: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    padding: 12px 10px;\n\n    ion-img {\n      height: 15px;\n    }\n  }\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.logo-block {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  .app-logo {\n    // margin-left: 4px;\n    width: 82px;\n    margin-bottom: 10px;\n  }\n  .title {\n    font-size: 21px !important;\n    font-family: var(--font-tusker);\n    color: var(--ion-color-secondary);\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
